import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: '¿Por qué sacaron esa foto?',
    author: 'Nadie entendía el contexto'
  }, {
    text: 'Pasé 3 horas armando el informe semanal.',
    author: 'Constructor'
  }];
  return <section id="problema" className="scroll-mt-20 py-16 sm:py-24 bg-white" data-id="element-218">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-219">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-6" data-id="element-220">
          EL PROBLEMA
        </motion.div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-[30px] sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-5 sm:mb-6 leading-[1.1] tracking-tight" data-id="element-221">
          Las fotos no se pierden.
          <span className="block text-blue-600 mt-2" data-id="element-222">
            Lo que se pierde es el contexto.
          </span>
        </motion.h2>

        {/* Subhead */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-2xl mx-auto mb-12 sm:mb-14 leading-relaxed" data-id="element-223">
          Quién la mandó. Qué mostraba. Qué se decidió después. En qué parte de
          la obra era.
        </motion.p>

        {/* Quote cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 text-left max-w-3xl mx-auto" data-id="element-224">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="relative bg-gray-50 border border-gray-200 rounded-2xl p-6 sm:p-8" data-id="element-225">
              <Quote className="w-5 h-5 sm:w-6 sm:h-6 text-blue-300 mb-3" data-id="element-226" />
              <p className="text-base sm:text-lg text-gray-900 font-medium leading-snug mb-4 sm:mb-5" data-id="element-227">
                "{problem.text}"
              </p>
              <p className="text-[11px] sm:text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-228">
                — {problem.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}